import {
  Stack,
  Text,
  Icon,
  Panel,
  PanelHeader,
  PanelTitle,
  PanelSection,
  InlineStack,
  StatusIndicator,
} from '@customerio/pluma-components/react';

import type { ServicesApiEnvHealthAlert } from '@/services/api/services-api';
import { SEVERITY_COLOR, useWorkspaceHealthSimulation, useEnvHealth } from '@/features/workspace-health';
import { getWorkspaceIdFromCurrentUrl } from '@/context/current-workspace';

// Alert titles that relate to messaging delivery and sending.
const MESSAGING_ALERT_TITLES = new Set([
  'Message delivery delayed',
  'Transactional delivery delayed',
  'Transactional messages delayed',
  'Webhook delivery backed up',
  'Broadcast sends backed up',
]);

function isMessagingAlert(alert: ServicesApiEnvHealthAlert): boolean {
  return MESSAGING_ALERT_TITLES.has(alert.title);
}

export function MessagingTabContent() {
  const workspaceId = getWorkspaceIdFromCurrentUrl() ?? 0;
  const { simulate } = useWorkspaceHealthSimulation();
  const healthQuery = useEnvHealth(workspaceId, simulate);
  const data = healthQuery.data;
  const alerts = data?.alerts ?? [];
  const messagingAlerts = alerts.filter(isMessagingAlert);

  return (
    <Panel>
      <PanelHeader>
        <PanelTitle>Alerts</PanelTitle>
      </PanelHeader>
      <PanelSection>
        {messagingAlerts.length > 0 ? (
          <Stack gap="150">
            {messagingAlerts.map((alert, index) => {
              return (
                <InlineStack key={index} gap="100" alignBlock="center">
                  <StatusIndicator color={SEVERITY_COLOR[alert.severity]} />
                  <Text size="s">{alert.message}</Text>
                </InlineStack>
              );
            })}
          </Stack>
        ) : (
          <InlineStack gap="100" alignBlock="center">
            <Icon name="check-circle" size="sm" color="success" />
            <Text size="s" color="subtle">
              No messaging alerts
            </Text>
          </InlineStack>
        )}
      </PanelSection>
    </Panel>
  );
}
